<template>
  <div>
    <v-card
      flat
      class="beez-bold py-1"
      v-if="showMetrics && !kpiLoader"
      :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
    >
      <v-flex d-flex xs12>
        <v-layout align-center justify-center row wrap>
          <v-flex
            v-for="(item, index) in taskCounts"
            :key="index"
            class="pa-1"
            lg3
            md4
            sm6
            xl2
            xs12
          >
            <kpi-card
              :heading="item.cnt"
              :sub-heading="
                item.description !== null
                  ? item.description
                  : item.dimension !== ''
                  ? item.dimension
                  : 'No Key'
              "
              @kpi-click="selectKPI(item.dimension)"
            ></kpi-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card>
    <v-expand-transition>
      <v-card flat v-show="showFilter">
        <v-toolbar dense flat>
          <div class="text-capitalize beez-bold">Task Filters</div>
        </v-toolbar>
        <v-card-text>
          <v-form ref="variableForm" v-model="validForm" class="pa-2">
            <v-layout align-center justify-space-between row wrap>
              <v-flex xs12 md6 class="pa-2">
                <v-text-field
                  v-model="executionId"
                  label="Tulip Task Identifier"
                  prepend-icon="fingerprint"
                  :rules="uuidRules"
                  mask="nnnnnnnn-nnnn-nnnn-nnnn-nnnnnnnnnnnn"
                  return-masked-value
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 class="pa-2">
                <v-select
                  v-model="selectedTaskProperties"
                  :hint="getTaskPropertyHint"
                  :items="getTaskProperties"
                  attach
                  chips
                  clearable
                  item-text="label"
                  item-value="value"
                  label="Select based on Task properties"
                  persistent-hint
                  prepend-icon="info"
                  return-object
                  rounded
                  single-line
                  style="padding-right: 10px;"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-if="data.item.value"
                      :selected="data.selected"
                      close
                      @input="removeTaskProperties(data.item)"
                    >
                      <v-avatar class="primary"
                        ><span class="white--text body-2">{{
                          data.item.label
                            .toString()
                            .charAt(0)
                            .toUpperCase()
                        }}</span></v-avatar
                      >
                      <strong>{{ data.item.label }}</strong>
                    </v-chip>
                  </template>
                </v-select>
              </v-flex>
              <v-flex class="pa-2" xs12>
                <v-select
                  v-model="selectedForms"
                  :items="myHoneyForms"
                  attach
                  chips
                  clearable
                  item-text="value"
                  item-value="key"
                  label="Select Forms"
                  multiple
                  prepend-icon="web"
                  rounded
                  style="padding-right: 10px;"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-if="data.item.key"
                      :selected="data.selected"
                      close
                      @input="removeFormKey(data.item)"
                    >
                      <v-avatar class="primary"
                        ><span class="white--text body-2">{{
                          data.item.value
                            .toString()
                            .charAt(0)
                            .toUpperCase()
                        }}</span></v-avatar
                      >
                      <strong>{{ data.item.value }}</strong>
                    </v-chip>
                  </template>
                </v-select>
              </v-flex>
              <v-flex class="pa-2" md6 xs12>
                <user-assignment-control
                  label="Raised By"
                  v-model="raisedBy"
                  multiple
                ></user-assignment-control>
              </v-flex>

              <v-flex xs12 md6 lg3 class="pa-2">
                <v-menu
                  v-model="fromDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedFromDate"
                      label="Tasks created from"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    :max="toDate"
                    @input="fromDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6 lg3 class="pa-2">
                <v-menu
                  v-model="toDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedToDate"
                      label="Tasks created till"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    :min="fromDate"
                    @input="toDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6 lg3 class="pa-2">
                <v-menu
                  v-model="dueFromMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDueFromDate"
                      label="Tasks due from"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dueFromDate"
                    :max="dueTillDate"
                    @input="dueFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6 lg3 class="pa-2">
                <v-menu
                  v-model="dueTillMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDueTillDate"
                      label="Tasks due till"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dueTillDate"
                    :min="dueFromDate"
                    @input="dueTillMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6 lg3 class="pa-2">
                <v-menu
                  v-model="followUpFromMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedFollowUpFromDate"
                      label="Tasks to be followed up from"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="followUpFromDate"
                    :max="followUpTillDate"
                    @input="followUpFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6 lg3 class="pa-2">
                <v-menu
                  v-model="followUpTillMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedFollowUpTillDate"
                      label="Tasks to be followed up till"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="followUpTillDate"
                    :min="followUpFromDate"
                    @input="followUpTillMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md6 lg3 class="pa-2">
                <v-checkbox
                  v-model="hideInProgressTask"
                  label="Hide Tasks In-progress"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :loading="taskLoader"
            class="text-capitalize"
            :disabled="!validForm"
            @click.stop="clearFilters"
          >
            <v-icon>clear</v-icon>&nbsp; Clear Filter
          </v-btn>
          <v-btn
            flat
            :loading="taskLoader"
            class="text-capitalize primary"
            :disabled="!validForm"
            @click.stop="applyFilters"
          >
            <v-icon>filter_alt</v-icon>&nbsp; Apply Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-expand-transition>
    <v-slide-y-transition>
      <v-chip v-if="filterApplied" class="body-2">
        Filter applied! &nbsp;<a @click="clearFilters">Click here</a>&nbsp; to
        clear
      </v-chip>
    </v-slide-y-transition>
  </div>
</template>

<script>
import UserAssignmentControl from '@/components/user-management/UserAssignmentControl'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import KpiCard from '@/components/common/KpiCard'
import _ from 'lodash'

export default {
  name: 'TaskFilterCard',
  components: {
    UserAssignmentControl,
    KpiCard
  },
  props: {
    hideInProgressTaskInput: {
      type: Boolean,
      default: false
    },
    refreshFlag: {
      type: Boolean,
      default: false
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    showMetrics: {
      type: Boolean,
      default: true
    },
    taskView: {
      type: String,
      default: 'claimed'
    }
  },
  data() {
    return {
      hideInProgressTask: false,
      filterApplied: false,
      kpiLoader: false,
      taskLoader: false,
      validForm: false,
      myHoneyForms: [],
      uuidRules: [
        v =>
          /^\s*$|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
            v
          ) || 'Invalid UUID'
      ],
      taskCounts: [],
      executionId: '',
      selectedForms: [],
      selectedTaskProperties: null,
      raisedBy: [],
      fromDateMenu: false,
      fromDate: '',
      toDateMenu: false,
      toDate: '',
      dueFromMenu: false,
      dueFromDate: '',
      dueTillMenu: false,
      dueTillDate: '',
      followUpFromMenu: false,
      followUpFromDate: '',
      followUpTillMenu: false,
      followUpTillDate: ''
    }
  },
  computed: {
    ...mapState({
      honeyUsers: state => state.honeyUsers.honeyUsers,
      currentUser: state => state.session.user,
      taskGroups: state => state.tasks.taskGroups,
      taskCountByFormKey: state => state.tasks.taskCountByFormKey,
      associatedFormKeys: state => state.tasks.associatedFormKeys
    }),
    ...mapGetters({
      can: 'can'
    }),
    computedFromDate() {
      return this.fromDate
        ? moment(this.fromDate).format('dddd, MMMM Do YYYY')
        : ''
    },
    computedToDate() {
      return this.toDate ? moment(this.toDate).format('dddd, MMMM Do YYYY') : ''
    },
    computedDueFromDate() {
      return this.dueFromDate
        ? moment(this.dueFromDate).format('dddd, MMMM Do YYYY')
        : ''
    },
    computedDueTillDate() {
      return this.dueTillDate
        ? moment(this.dueTillDate).format('dddd, MMMM Do YYYY')
        : ''
    },
    computedFollowUpFromDate() {
      return this.followUpFromDate
        ? moment(this.followUpFromDate).format('dddd, MMMM Do YYYY')
        : ''
    },
    computedFollowUpTillDate() {
      return this.followUpTillDate
        ? moment(this.followUpTillDate).format('dddd, MMMM Do YYYY')
        : ''
    },
    getTaskPropertyHint() {
      let hint = this.selectedTaskProperties
        ? 'Applicable for ' +
            this.selectedTaskProperties.count +
            ' task(s) with key: ' +
            this.selectedTaskProperties.formKeyDesc ||
          this.selectedTaskProperties.formKey
        : ''
      return hint
    },
    getTaskProperties() {
      let labels = []
      if (this.taskGroups && this.taskGroups.length === 4) {
        this.taskGroups[0].dimension1.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension1',
            value: 'dimension1' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[1].dimension2.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension2',
            value: 'dimension2' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[2].dimension3.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension3',
            value: 'dimension3' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[3].dimension4.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension4',
            value: 'dimension4' + ':' + item.dimension + ':' + item.formKey
          })
        })
      }

      return _.uniqBy(labels, function(e) {
        return e.value
      })
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    associatedFormKeys() {
      this.myHoneyForms = []
      for (let key in this.associatedFormKeys) {
        if (this.associatedFormKeys.hasOwnProperty(key)) {
          let obj = {}
          obj.key = key
          obj.value = this.associatedFormKeys[key]
          this.myHoneyForms.push(obj)
        }
      }
    },
    refreshFlag() {
      this.init()
    },
    taskView() {
      this.init()
    },
    taskCountByFormKey() {
      this.kpiLoader = true
      this.taskCounts = this.taskCountByFormKey
      this.taskCounts.map(value => {
        value.description = this.associatedFormKeys[value.dimension] || null
      })
      this.kpiLoader = false
    },
    hideInProgressTaskInput() {
      this.init()
      this.applyFilters()
      if (!this.hideInProgressTaskInput) {
        this.filterApplied = false
      }
    }
  },
  methods: {
    async init() {
      this.kpiLoader = true
      this.setFilterObjFromInput()
      await this.getAssociatedFormKey()
      await this.getTasksCountByFormKey()
      this.kpiLoader = false
    },
    async getTasksCountByFormKey() {
      let urlParams = null
      if (this.taskView === 'claimed') {
        await this.$store.dispatch('fetchTasksCountByFormKey', urlParams)
      } else {
        await this.$store.dispatch('fetchTasksCountByFormKeyByGroup', urlParams)
      }
    },
    async getAssociatedFormKey() {
      let urlParams = null
      if (this.taskView === 'claimed') {
        await this.$store.dispatch('fetchAssociatedFormKey', urlParams)
      } else {
        await this.$store.dispatch('fetchAssociatedFormKeyByGroup', urlParams)
      }
    },
    setFilterObjFromInput() {
      this.hideInProgressTask = this.hideInProgressTaskInput
    },
    selectKPI(item) {
      this.clearFilterFields()
      this.selectedForms.push(item)
      this.applyFilters()
    },
    clearFilterFields() {
      this.executionId = ''
      this.selectedForms = []
      this.fromDate = ''
      this.toDate = ''
      this.dueFromDate = ''
      this.dueTillDate = ''
      this.followUpFromDate = ''
      this.followUpTillDate = ''
      this.taskProperties = ''
    },
    clearFilters() {
      this.clearFilterFields()
      this.applyFilters()
      this.filterApplied = false
    },
    applyFilters() {
      let filterObj = {}
      filterObj.executionId = this.executionId
      filterObj.honeyForms = this.selectedForms
      filterObj.taskProperties = this.selectedTaskProperties
      filterObj.fromDate = this.fromDate
      filterObj.toDate = this.toDate
      filterObj.dueFromDate = this.dueFromDate
      filterObj.dueTillDate = this.dueTillDate
      filterObj.followUpFromDate = this.followUpFromDate
      filterObj.followUpTillDate = this.followUpTillDate
      filterObj.hideInProgressTask = this.hideInProgressTask
      filterObj.urlString = this.fillUrlParams(filterObj)
      this.$emit('filterUpdated', filterObj)
      this.filterApplied = true
    },

    fillUrlParams(filterObj) {
      let urlParams = ''
      if (filterObj.fromDate) {
        urlParams =
          urlParams +
          `&fromDate=${moment(filterObj.fromDate, 'YYYY-MM-DD').toISOString()}`
      }
      if (filterObj.toDate) {
        urlParams =
          urlParams +
          `&toDate=${moment(filterObj.toDate, 'YYYY-MM-DD').toISOString()}`
      }
      if (filterObj.dueFromDate) {
        urlParams =
          urlParams +
          `&dueFrom=${moment(
            filterObj.dueFromDate,
            'YYYY-MM-DD'
          ).toISOString()}`
      }
      if (filterObj.dueTillDate) {
        urlParams =
          urlParams +
          `&dueTill=${moment(
            filterObj.dueTillDate,
            'YYYY-MM-DD'
          ).toISOString()}`
      }
      if (filterObj.followUpFromDate) {
        urlParams =
          urlParams +
          `&followUpFrom=${moment(
            filterObj.followUpFromDate,
            'YYYY-MM-DD'
          ).toISOString()}`
      }
      if (filterObj.followUpTillDate) {
        urlParams =
          urlParams +
          `&followUpTill=${moment(
            filterObj.followUpTillDate,
            'YYYY-MM-DD'
          ).toISOString()}`
      }
      if (filterObj.honeyForms && filterObj.honeyForms.length > 0) {
        urlParams = urlParams + `&formKeysIn=${filterObj.honeyForms.toString()}`
      }
      if (filterObj.taskProperties) {
        let labelItem = this.getTaskProperties.find(
          i => i.value === filterObj.taskProperties.value
        )
        urlParams = urlParams + `&${labelItem.dimension}=${labelItem.label}`
      }
      if (filterObj.hideInProgressTask) {
        urlParams = urlParams + '&inProgress=false'
      }
      return urlParams
    },
    removeFormKey(item) {
      let index = this.selectedForms.findIndex(i => i === item.key)
      if (index !== -1) this.selectedForms.splice(index, 1)
    },
    removeTaskProperties() {
      this.selectedTaskProperties = null
    }
  }
}
</script>

<style scoped></style>
